import { useShortlistFill } from "PFCore/hooks/queries/shortlists/use_shortlist_actions";
import { useShortlistCreate } from "PFCore/hooks/queries/shortlists/use_shortlist_create";
import { useErrorsGrowl } from "PFCore/hooks/use_errors_growl";
import { Activity, Id } from "PFTypes";
import { useCallback } from "react";

export const useShortlistAndFillAction = () => {
  const growlError = useErrorsGrowl();

  const { mutateAsync: fill, isPending: isFilling } = useShortlistFill();
  const { mutateAsync: createShortlist, isPending: isCreatingShortlist } = useShortlistCreate();

  const handleFill = useCallback(
    async ({
      activity,
      profileId,
      shortlistId,
      vacancyId,
      named = true
    }: {
      activity: Activity;
      profileId: Id;
      shortlistId?: Id;
      vacancyId?: Id;
      named?: boolean;
    }) => {
      try {
        const finalShortlistId =
          shortlistId || (await createShortlist({ activityId: activity.id, profileId, named })).id;

        const response = await fill({
          id: finalShortlistId,
          vacancyId: Number(vacancyId)
        });

        return response;
      } catch ({ response }) {
        growlError(response);
      }
    },
    [createShortlist, fill, growlError]
  );

  const isLoading = isFilling || isCreatingShortlist;

  return {
    isLoading,
    handleFill
  };
};
